module.exports = __webpack_public_path__ + "static/us_ccof_organic-06bb27e6fdc3c5e2e26f9e5865243e52.png";